<script setup lang="ts">
import { useBreakpoints } from '@monolith/legacy/modules/design-system-candidates';
import type { ESProductHit } from '@bc/discovery/domain/catalog';
import { CardProductProps } from '../types/card-product-props';
import { CardProductEmits } from '../types/card-product-emits';
import CardProduct from './card-product.vue';
import CardProductSimilarProducts from './card-product-similar-products.vue';
import { useSimilarProductsDrawer } from '@bc/discovery/feature/catalog/composables/use-similar-products-drawer';
import { SimilarProductsButton } from '@bc/discovery/ui/recommendation';
import { useProductViewModelFull } from '../composables/use-product-viewmodel-full';
import { isTileSimplified } from '../services/tile-simplification';

defineOptions({
  name: 'CardProductCategory',
});

const props = defineProps<CardProductProps>();
defineEmits<CardProductEmits>();

const { isAboveOrEqualLg } = useBreakpoints();

const { openSimilarProductsDrawer } = useSimilarProductsDrawer({
  product: props.product as unknown as ESProductHit,
  pageNumber: props.pageNumber + 1,
  position: props.position,
  productComponent: CardProductSimilarProducts,
});

const { productViewModel } = useProductViewModelFull(props);
</script>

<template>
  <CardProduct
    :product="productViewModel"
    :qtac-product="product as ESProductHit"
    :page-number="pageNumber"
    :position="position"
    :can-get-wholesale-price="canGetWholesalePrice"
    :is-user-authenticated="isUserAuthenticated"
    with-drawer
    @clicked-drawer="$emit('clickedDrawer', $event)"
    @clicked="$emit('clicked', $event)"
    @brand-clicked="$emit('brandClicked', $event)"
    @add-to-cart-clicked="$emit('addToCartClicked', $event)"
    @added-to-cart="$emit('addedToCart', $event)"
    @like-clicked="$emit('likeClicked', $event)"
    @unlike-clicked="$emit('unlikeClicked', $event)"
  >
    <template #topRightActions="{ isHovered }">
      <SimilarProductsButton
        v-if="!isTileSimplified()"
        :is-focused="isHovered"
        :with-tooltip="isAboveOrEqualLg"
        @click="openSimilarProductsDrawer"
      />
    </template>
  </CardProduct>
</template>
